import loadable from '@loadable/component'

export const RatingsCriteriaReportTable = loadable(
  () => import('./RatingsCriteriaReportTable')
)

export type {
  RatingsCriteriaReportTableItemProps,
  RatingsCriteriaReportTableProps
} from './RatingsCriteriaReportTable'
